import { css } from 'styled-components';
import mainColors from '../../main-colors';

export const sharedInputStyles = css`
  position: relative;

  .error-message {
    color: ${mainColors.error_color};
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
  }

  .password-field {
    padding-right: 32px;
  }

  .phone-field {
    padding-left: 50px;
  }

  .numeric-field {
    text-align: center; /// center the input field inside this container

    .minus-btn,
    .plus-btn {
      position: absolute;
      top: 50%;
      width: 30px;
      height: 30px;
      border: none;
      background-color: transparent;
      font-size: 18px;
      cursor: pointer;
      color: ${mainColors.main_color};
    }

    .minus-btn {
      transform: translateY(-50%);
    }

    .plus-btn {
      transform: translate(-100%, -50%);
    }
  }

  .input-field-with-icon-container {
    position: relative;

    .show-hide-icon {
      position: absolute;
      bottom: 5px;
      right: 1px;
      cursor: pointer;
      opacity: 0;

      transition: opacity 0.3s ease-in-out;
      pointer-events: none; /* Prevent interaction when hidden */

      svg {
        width: 25px;
        height: 25px;
        fill: ${mainColors.main_color};
        stroke: ${mainColors.main_color};
      }
    }

    &:focus-within .show-hide-icon {
      display: block;
      opacity: 1;
      pointer-events: auto; /* Enable interaction when visible */
    }

    .number-prefix {
      position: absolute;
      left: 8px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 18px;
      opacity: 0.8;
    }
  }
`;
